export default "__VITE_ASSET__5603dad4__"